import { ReactElement } from "react";
import HeaderLabelWithTooltip from "../../components/Organismos/Table/HeaderLabelWithTooltip";
import { IntegratorRunStatus } from "../../interfaces/models/IIntegratorRunLog";
import { statusLabel } from "./runLogs/runLogDisplay";

const ICON_CLASS = "h-4 w-4";

function CheckIcon(): ReactElement {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" className={ICON_CLASS} aria-hidden>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function InfoIcon(): ReactElement {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" className={ICON_CLASS} aria-hidden>
      <path
        fillRule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function ErrorIcon(): ReactElement {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" className={ICON_CLASS} aria-hidden>
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function statusIcon(status: IntegratorRunStatus): {
  icon: ReactElement;
  className: string;
} {
  if (status === "success") {
    return { icon: <CheckIcon />, className: "bg-green-100 text-green-700" };
  }
  if (status === "error") {
    return { icon: <ErrorIcon />, className: "bg-red-100 text-red-700" };
  }
  return { icon: <InfoIcon />, className: "bg-blue-100 text-blue-700" };
}

export default function LastRunDateCell({
  date,
  status,
}: {
  date: string;
  status?: IntegratorRunStatus;
}): ReactElement {
  if (!status) {
    return <>{date}</>;
  }

  const label = statusLabel(status);
  const { icon, className } = statusIcon(status);

  return (
    <span className="inline-flex items-center gap-1.5">
      {date}
      <HeaderLabelWithTooltip
        tooltip={label}
        label={
          <span
            className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${className}`}
            aria-label={label}
          >
            {icon}
          </span>
        }
      />
    </span>
  );
}
